import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import {
  Button,
  Grid,
  Header,
  Modal,
} from 'semantic-ui-react';

import { flashErrorMessage, flashSuccessMessage } from '../../actions/flash';
import { promptChangesMessage } from '../../actions/prompt';
import BranchLogoList from '../../components/BranchLogoList';
import UploadModal from '../../components/UploadModal';
import { TRANSLATION_FILES } from '../../constants/translation';
import ViewLarge from './ViewLarge';

import {
  UPLOAD_LOGO_PROMPT,
} from '../../constants/promptMessages';

import Form from '../Logos/Form';

class AddBranchLogo extends Component {
  static contextTypes = {
    store: PropTypes.object,
  }
  static propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func,
    onConfirm: PropTypes.func,
    onUpload: PropTypes.func,
    onCheck: PropTypes.func,
    t: PropTypes.func,
  }
  constructor(props) {
    super(props);
    this.state = {
      showLarge: false,
      selectedLogo: null,
    };
  }
  fixBody = () => {
    const anotherModal = document.getElementsByClassName('ui page modals');
    if (anotherModal.length > 0) {
      document.body.classList.add('dimmable', 'dimmed');
    }
  }
  handleRefetch() {
    if (this.logoList) {
      this.logoList.getWrappedInstance().handleRefetch();
    }
  }
  handleViewLarge = (e, selectedLogo) => {
    e.preventDefault();
    this.setState({ selectedLogo }, () => {
      this.setState({
        showLarge: true,
      });
    });
  }
  handleCloseLarge = (e) => {
    e.preventDefault();
    this.setState({
      showLarge: false,
      selectedLogo: null,
    });
  }
  handleAddBranchLogo = (e, selectedLogo) => {
    e.preventDefault();
    if (this.props.onConfirm) {
      this.props.onConfirm(e, selectedLogo);
    }
    this.setState({
      selectedLogo: null,
    }, () => {
      this.fixBody();
    });
  }
  handleOnClose = (e) => {
    if (this.props.onClose) {
      this.props.onClose(e);
    }
  }
  checkAdded(data) {
    if (this.props.onCheck) {
      return this.props.onCheck(data);
    }
    return false;
  }
  handleOnUpload = async (e, data) => {
    if (this.props.onUpload) {
      e.preventDefault();
      const { url, options } = await this.props.onUpload(data);
      if (url && options) {
        this.upload(url, options);
      }
    }
  }
  async upload(url, options) {
    const { t } = this.props;
    const { store } = this.context;
    try {
      await this.form.getWrappedInstance().submit(url, options);
    } catch (err) {
      if (err.res && err.res.status >= 400 && err.res.status < 500) {
        let message = await err.res.text();
        if (err.res.status === 413) {
          message = 'Uploaded image too large';
        }
        store.dispatch(flashErrorMessage({ message }));
        return;
      }
      store.dispatch(flashErrorMessage(err));
      return;
    }
    this.uploadModal.close();
    this.handleRefetch();
    store.dispatch(flashSuccessMessage({ header: t('Upload Success', { ns: TRANSLATION_FILES.translation }), message: t('Picture(s) successfully uploaded', { ns: TRANSLATION_FILES.translation }) }));
  }
  handleCheckBeforeClose = () => {
    const { t } = this.props;
    if (this.form.getWrappedInstance().state.uploads.length > 0) {
      const callback = () => {
        this.form.getWrappedInstance().resetFiles();
        this.uploadModal.close();
        this.handleRefetch();
      };
      const { store } = this.context;
      store.dispatch(promptChangesMessage({ message: t(UPLOAD_LOGO_PROMPT, { ns: TRANSLATION_FILES.translation }), callback }));
      return true;
    }
    return false;
  }
  render() {
    const { t } = this.props;
    return (
      <Modal
        className="add-picture"
        open={this.props.open === true}
        onClose={this.handleOnClose}
        closeIcon="close"
        size="large"
      >
        <Header icon="image outline" content={t('Add logos', { ns: TRANSLATION_FILES.translation })} />
        <Modal.Content scrolling>
          <Grid verticalAlign="middle" columns="equal">
            <Grid.Row>
              <Grid.Column>
                <ViewLarge
                  open={this.state.showLarge}
                  onClose={this.handleCloseLarge}
                  picture={this.state.selectedLogo}
                  pictureSize={50}
                  extension="png"
                />
                <BranchLogoList
                  ref={(ref) => { this.logoList = ref; }}
                  toggleable
                  onViewLarge={this.handleViewLarge}
                  onRemove={this.handleRemove}
                  buttonNode={({ view, loading, logo }) => (
                    <Button
                      compact size="small"
                      primary={!this.checkAdded(logo)}
                      positive={this.checkAdded(logo)}
                      icon={this.checkAdded(logo) ? 'checkmark' : 'add'}
                      content={this.checkAdded(logo) ? t('Added', { ns: TRANSLATION_FILES.translation }) : t('Add', { ns: TRANSLATION_FILES.translation })}
                      disabled={this.checkAdded(logo) || loading}
                      onClick={e => this.handleAddBranchLogo(e, logo)}
                    />
                  )}
                  searchRightNav={
                    <UploadModal
                      floated="right"
                      header="logos"
                      ref={(ref) => { this.uploadModal = ref; }}
                      onConfirm={this.handleOnUpload}
                      onClose={this.handleCheckBeforeClose}
                      content={({ onConfirm }) => (
                        <Form
                          ref={(ref) => { this.form = ref; }}
                          onSubmit={onConfirm}
                        />
                      )}
                    />
                  }
                />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Modal.Content>
      </Modal>
    );
  }
}

export default withTranslation()(AddBranchLogo);




// WEBPACK FOOTER //
// ./src/containers/modals/AddBranchLogo.jsx